export type IventisWebsocketOptions<TEventType> = {
    /** The payload to send in the keep alive event */
    keepAlivePayload: TEventType;

    /** How many times can this websocket connection reconnect? < 0 means infinite reconnect attempts */
    reconnectMaxAttempts?: number;

    /** What is the maximum time a reconnection should wait for? */
    reconnectMaxInterval?: number;

    /** How often should we send the keep alive event? */
    keepAliveIntervalTime?: number;
};
